import _Home from "@mui/icons-material/Home";
var _templateObject, _templateObject2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import NavBarItem from 'app/components/navBar/NavBarItem';
import styled from 'styled-components';
import { FuPaPlayer } from 'app/components/icons';
import { COLORS, SIZES } from '@fupa/fupa-uikit';
const StyledFuPaPlayer = styled(FuPaPlayer).withConfig({
  componentId: "sc-1446as1-0"
})(["&&&{color:", ";font-size:20;padding-left:", ";", " path:last-child{fill:", ";}}"], props => props.selected ? COLORS.fupaSecondary : COLORS.darkerGrey, SIZES[2], props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      display: none;\n    "]))), props => props.selected ? COLORS.white : COLORS.darkerGrey);
const StyledHome = styled(_Home).withConfig({
  componentId: "sc-1446as1-1"
})(["&&&{color:", ";font-size:20;display:none;", "}"], props => props.selected ? COLORS.fupaSecondary : COLORS.lighterGrey, props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      display: flex;\n      padding-bottom: 0.75rem;\n    "]))));
export default function NavBarItemHome(_ref) {
  let {
    isSelected,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(NavBarItem, _extends({
    isSelected: isSelected,
    follow: true,
    label: "Home"
  }, props, {
    "data-sentry-element": "NavBarItem",
    "data-sentry-component": "NavBarItemHome",
    "data-sentry-source-file": "NavBarItemHome.tsx"
  }), /*#__PURE__*/React.createElement(StyledFuPaPlayer, {
    selected: isSelected,
    "data-sentry-element": "StyledFuPaPlayer",
    "data-sentry-source-file": "NavBarItemHome.tsx"
  }), /*#__PURE__*/React.createElement(StyledHome, {
    selected: isSelected,
    "data-sentry-element": "StyledHome",
    "data-sentry-source-file": "NavBarItemHome.tsx"
  }));
}